<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card
        tile
        color="blue-grey lighten-4"
        class="d-flex flex-column align-center"
      >
        <v-avatar class="my-5" size="72">
          <img alt="mastertech.co.th" src="../assets/logo-taff-120.svg" />
        </v-avatar>
        <h2 class="font-weight-regular grey--text text--darken-3">
          Log In to masterTime
        </h2>
        <v-card class="my-5" rounded width="380">
          <v-card-text>
            <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
              <p class="mb-1">Email address</p>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                outlined
                dense
              ></v-text-field>
              <p class="mb-1">Password</p>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                outlined
                dense
              ></v-text-field>
              <v-btn
                block
                class="mt-3"
                type="submit"
                color="primary"
                :loading="loading"
              >
                Login
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
        <!-- <v-row>
          <v-col>
            <p class="caption">Terms</p>
          </v-col>
          <v-col>
            <p class="caption">Privacy</p>
          </v-col>
          <v-col>
            <p class="caption">Security</p>
          </v-col>
          <v-col>
            <p class="caption">Contact</p>
          </v-col>
        </v-row> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      dialog: true,
      email: '',
      password: '',
      showPassword: false,
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) =>
          (v && v.length <= 128) || 'Password must be less than 128 characters',
      ],
      timeout: null,
    }
  },
  created() {
    window.localStorage.clear()
    this.$router.push({ name: 'Home' })
  },
  methods: {
    ...mapActions({
      software3rdParty: 'authentication/software3rdParty',
      login: 'authentication/login',
      fetchHardwareModels: 'hardware/fetchHardwareModels',
    }),
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true

          const payload = {
            app_id: process.env.VUE_APP_APP_ID,
            secret: process.env.VUE_APP_SECRET,
            app_bundle_id: '',
            login_type_id: 1, // login from web
            timezone: moment().format('Z'),
          }
          await this.software3rdParty(payload)

          const auth = {
            email: this.email.trim(),
            password: this.password,
            login_type_id: 1, // login from web
            timezone: moment().format('Z'),
          }
          await this.login(auth)

          const { company_uuid } = this.$store.state.authentication.company
          await this.fetchHardwareModels({ params: { company_uuid } })

          this.dialog = false

          this.timeout = setTimeout(() => {
            this.$router.push({ name: 'Home' })
          }, 200)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.loading = false
        }
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
